module.exports = __webpack_public_path__ + "static/media/weighBeltFeeder1.ad17e4b0.png";